import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import SideBar from "../components/sidebar/sidebar";
import { useState } from "react";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  return (
    <div>
      <Header />
      <div style={{ display: "grid", gridTemplateColumns: "auto 4fr" }}>
        <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="container-fluid p-0">
          <main>
            <div className="main_standard">{children}</div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};
export default Layout;
